import { Button } from 'react-bootstrap';

interface IProps {
    username: string
}

const Success = (props: IProps) => {
    return (
        <>
            <div className='verify-card-header'>
                <span className='step'>Step 3 of 3</span>
                <h4>Welcome to the NKR</h4>
            </div>
            <div className='verify-card-body'>
                <p>Congratulations! Your account is now ready.</p>

                <div className='username'>
                    <span className='k'>Your username</span>
                    <span className='v'>{props.username}</span>
                </div>

                <p>Use this username and your new password to log in.</p>
            </div>
            <div className='verify-card-footer'>
                <Button type='submit' bsStyle='primary'>Go to Login</Button>
            </div>
        </>
    );
}

export default Success;
